import { Component } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
// import { BeforePopupMHComponent } from './before-question/before-popup.component';

export const CARDIOVASCULAR_DISEASE_CHINA_VIDEOS = [
        {
            topic: 'CVD: Hypertension',
            text: 'Prof S. Bangalore helps you understand hypertension.',
            bullets: [
                'Click the play button on the bottom left to continue',
                'Click on the square icon to view in full screen',
                'Video Length: 5.41 Minutes',
            ],
            url: 'https://patient-academy.s3.ap-east-1.amazonaws.com/2.Hypertension.mp4',
            poster: 'assets/img/cardiovascular-disease-poster-hypertension.png',
            videoNumber: 2,
        },
];

@Component({
    selector: 'app-cardiovascular-disease-china',
    templateUrl: './cardiovascular-disease-china.component.html',
    styleUrls: ['./cardiovascular-disease-china.component.scss'],
})
export class CardioVascularDiseaseChinaComponent {
    constructor(private dialog: MatDialog) {}

    videos = CARDIOVASCULAR_DISEASE_CHINA_VIDEOS;

    //https://patient-academy.s3.ap-east-1.amazonaws.com/2.Hypertension.mp4
    // beforePlayVideo(video) {
    //     // if (localStorage.getItem('isSubmitted') !== 'true') {
    //     //     video.pause();
    //     //     this.openBeforeQuestion(video);
    //     // }
    // }

    // openBeforeQuestion(video, data: any = {}, isNew?) {
    //     const title = isNew ? 'Take Survey' : 'Update Survey';
    //     const dialogRef: MatDialogRef<any> = this.dialog.open(BeforePopupMHComponent, {
    //         width: '1024px',
    //         disableClose: true,
    //         data: { title: title, faq: data },
    //     });

    //     dialogRef.afterClosed().subscribe((res) => {
    //         video.play();
    //         if (!res) {
    //             return;
    //         }
    //         // if (isNew) {
    //         //     // this.createSurvey(res);
    //         //     video.play();
    //         // } else {
    //         //     // this.updateSurvey(res);
    //         //     video.play();
    //         // }
    //     });
    // }
}
